import { Link } from "react-router-dom";

const friendLinks = [
  { label: "影视资讯", to: "/special" },
  { label: "剧情速览", to: "/category/movie" },
  { label: "热门剧集", to: "/category/tv" },
  { label: "短剧推荐", to: "/category/web" },
];

export default function Footer() {
  return (
    <footer className="mt-16 bg-primary-900 text-primary-100">
      <div className="w-full px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-4 lg:gap-10">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2">
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-accent-500 text-background-50">
                <i className="ri-movie-2-line text-xl"></i>
              </span>
              <span className="font-heading text-lg font-bold text-background-50">
                妻子的朋友
              </span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-primary-200">
              妻子的朋友是专注影视剧情介绍与观影推荐的内容门户。我们整理电影、电视剧与网络剧的剧情脉络、角色分析与精选推荐，
              帮助你在海量作品中快速找到想看的下一部。
            </p>
            <p className="mt-4 text-xs text-primary-300">
              本站全部内容为演示数据，未接入真实影视数据库、播放或下载接口。
            </p>
          </div>

          <div>
            <h2 className="text-sm font-semibold text-background-50">快速导航</h2>
            <ul className="mt-4 space-y-2 text-sm">
              <li>
                <Link to="/" className="hover:text-accent-300 cursor-pointer">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/special" className="hover:text-accent-300 cursor-pointer">
                  专题合集
                </Link>
              </li>
              <li>
                <Link to="/search" className="hover:text-accent-300 cursor-pointer">
                  搜索
                </Link>
              </li>
              <li>
                <Link to="/about" className="hover:text-accent-300 cursor-pointer">
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h2 className="text-sm font-semibold text-background-50">友情链接</h2>
            <ul className="mt-4 space-y-2 text-sm">
              {friendLinks.map((l) => (
                <li key={l.label}>
                  <Link to={l.to} className="hover:text-accent-300 cursor-pointer">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-start justify-between gap-3 border-t border-primary-800 pt-6 text-xs text-primary-300 sm:flex-row sm:items-center">
          <span>© {new Date().getFullYear()} 妻子的朋友 · 影视剧情门户</span>
          <span className="flex flex-wrap gap-4">
            <Link to="/about" className="hover:text-accent-300 cursor-pointer">
              版权声明
            </Link>
            <Link to="/about" className="hover:text-accent-300 cursor-pointer">
              联系我们
            </Link>
          </span>
        </div>
      </div>
    </footer>
  );
}